import React, { useState } from "react"
import "./HideUnhideDiv.scss"
import { selectIcon, SVG } from "../../../components/UI/selector"

const HideUnhideDiv = ({ clas, clasType, ...props }) => {
  const [hide, setHide] = useState(false)
  const theme = getComputedStyle(document.documentElement).getPropertyValue(
    "--theme-color"
  )
  return (
    <React.Fragment>
      <div
        className={`${clasType} hideUnhideDiv${hide ? " active" : ""}`}
        onClick={() => setHide(!hide)}
      >
        <SVG
          className={theme === "light" ? "lightSvg" : "darkSvg"}
          src={selectIcon("arrowIcon")}
        />
      </div>
      <div className={`${clas} ${clasType}${hide ? " hide" : ""}`}>
        {props.children}
      </div>
    </React.Fragment>
  )
}

export default HideUnhideDiv
